(function () {
  function initBookFaqs() {
    const sections = document.querySelectorAll('.book_faqs ._section');

    sections.forEach(function (section) {
      if (section.dataset.bookfaqsBound === 'true') return;
      section.dataset.bookfaqsBound = 'true';

      const allowMultiple = section.dataset.allowMultiple === 'true';

      section.addEventListener('click', function (e) {
        const trigger = e.target.closest('._bookfaqs-trigger');
        if (!trigger || !section.contains(trigger)) return;

        const item = trigger.closest('._bookfaqs-item');
        if (!item) return;

        const willOpen = !item.classList.contains('-open');

        if (!allowMultiple && willOpen) {
          section.querySelectorAll('._bookfaqs-item.-open').forEach(function (open) {
            if (open === item) return;
            open.classList.remove('-open');
            const t = open.querySelector('._bookfaqs-trigger');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
        }

        item.classList.toggle('-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBookFaqs);
  } else {
    initBookFaqs();
  }
})();